import { render } from "./ihbook_page_i.vue?vue&type=template&id=64d8b963&scoped=true"
const script = {}

import "./ihbook_page_i.vue?vue&type=style&index=0&id=64d8b963&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d8b963"]])

export default __exports__